import { render, staticRenderFns } from "./CAIG0040.vue?vue&type=template&id=95ee2b16"
import script from "./CAIG0040Controller.ts?vue&type=script&lang=ts&external"
export * from "./CAIG0040Controller.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports